import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const CreditCardIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3.59998C1.44772 3.59998 1 4.04769 1 4.59998V18.6C1 19.1523 1.44772 19.6 2 19.6H22C22.5523 19.6 23 19.1523 23 18.6V4.59998C23 4.04769 22.5523 3.59998 22 3.59998H2ZM3 7.90002V5.59998H21V7.90002H3ZM3 9.90002V17.6H21V9.90002H3Z"
      />
    </Icon>
  );
};
